import {createTheme} from 'styled-breakpoints'

export const breakPointTheme = createTheme({
  breakPoint: '601px',
  mobile: '601px',
  tablet: '992px',
  pc: '1220px'
})
